import { Component } from '@angular/core';

@Component({
  selector: 'app-scintillating-loader',
  templateUrl: './scintillating-loader.component.html',
  styleUrls: ['./scintillating-loader.component.scss'],
})
export class ScintillatingLoaderComponent {}
